
import AppLayout from '../../components/feature/AppLayout';
import ClientsSection from '../home/components/ClientsSection';

export default function CreatorsPage() {
  return (
    <AppLayout>
      <ClientsSection />
    </AppLayout>
  );
}
